import {callsApi} from 'sources/api';
import {List} from 'immutable';
import ScorecardSchemeLabel from 'records/ScorecardSchemeLabel';

export default {
  labels() {
    return callsApi
      .getJson('/scoring-scheme-labels')
      .then(schemeLabels => List(schemeLabels.map(scheme => new ScorecardSchemeLabel(scheme))));
  },

  save(labels) {
    return callsApi.put('/scoring-scheme-labels', labels).then(schemeLabels => {
      List(schemeLabels.data.map(scheme => new ScorecardSchemeLabel(scheme)));
    });
  },
};
